import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

const emailjsConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_61qtord",
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_3jxexrg",
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "4IYQa1R7uBDvheUmy",
};

export const Contact = ({ data }) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const contactEmail = data ? data.email : "james@asyncjam.com";

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((previousState) => ({ ...previousState, [name]: value }));
    if (status !== "idle") {
      setStatus("idle");
      setErrorMessage("");
    }
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("sending");
    setErrorMessage("");

    try {
      await emailjs.send(
        emailjsConfig.serviceId,
        emailjsConfig.templateId,
        {
          name,
          email,
          message,
          from_name: name,
          reply_to: email,
          to_email: contactEmail,
        },
        {
          publicKey: emailjsConfig.publicKey,
        }
      );
      clearState();
      setStatus("sent");
    } catch (error) {
      console.error("Contact form failed to send", error);
      const providerMessage = error && (error.text || error.message);
      setErrorMessage(
        providerMessage
          ? `EmailJS rejected the message: ${providerMessage}`
          : "The form could not send right now. Please email us directly instead."
      );
      setStatus("error");
    }
  };

  return (
    <footer id="contact" className="contact-section">
      <div className="contact-grid">
        <div className="contact-copy">
          <p className="eyebrow">Get in touch</p>
          <h2>Got a stuck workflow or a suspiciously good idea?</h2>
          <p>{data ? data.note : "Tell us what you are trying to make."}</p>
          <a className="mail-link" href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
        </div>

        <form className="contact-form" name="sentMessage" onSubmit={handleSubmit}>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Your name"
            required
            value={name}
            onChange={handleChange}
          />

          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="you@example.com"
            required
            value={email}
            onChange={handleChange}
          />

          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            id="message"
            rows="5"
            placeholder="What are we making?"
            required
            value={message}
            onChange={handleChange}
          />

          <button type="submit" className="button-primary" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send message"}
          </button>

          <div className={`form-status form-status-${status}`} role="status" aria-live="polite">
            {status === "sent" && "Thanks. Your message has been sent."}
            {status === "error" && (
              <>
                {errorMessage}{" "}
                <a href={`mailto:${contactEmail}?subject=Website enquiry`}>{contactEmail}</a>
              </>
            )}
          </div>
        </form>
      </div>
      <div className="site-footer">&copy; 2026 Async Jam</div>
    </footer>
  );
};
